import { AccessTokenResponse, AccessTokenResponseWrapper } from 'com.cogvio.pricemonitor.api';
import { useEffect, useState } from 'react';
import { apiClientMutator } from '~/infrastructure/config/mutator';
import { getStorageData, StorageType } from '~/libs/utils/storage/storage';

export function useAccessToken() {
	const [accessToken, setAccessToken] = useState<AccessTokenResponse | null>(
		getStorageData(StorageType.ACCESS_TOKEN_OBJECT)
	);

	useEffect(() => {
		const fetchAccessToken = async () => {
			if (!accessToken) {
				const data = await apiClientMutator<AccessTokenResponseWrapper>({
					url: '/authentication',
					method: 'get',
				});
				return data.accessToken;
			}
			return accessToken;
		};

		fetchAccessToken().then((accessTokenResponse) => setAccessToken(accessTokenResponse));
	}, []);

	return accessToken;
}
